<script>
	import request from './request.vue';

	import { format } from "date-fns";

	const companySchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da empresa",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome da empresa",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "logoUrl",
			displayName: "Logo",
			kind: "text",
			validation: "",
			placeholder: "",
		},
		{
			name: "urlCode",
			displayName: "Código da URL",
			kind: "text",
			validation: "",
			placeholder: "",
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "colorPrimary",
			displayName: "Cor Primária",
			kind: "color-picker",
			placeholder: "Digite a cor em hexadecimal com 6 dígitos. (#0123456)",
			validation: "length:7"
		},
		{
			name: "colorSecondary",
			displayName: "Cor Secundária",
			kind: "color-picker",
			placeholder: "Digite a cor em hexadecimal com 6 dígitos. (#0123456)",
			validation: "length:7"
		},
		{
			name: "defaultPassword",
			displayName: "Senha padrão",
			validation: "required",
			kind: "text",
			placeholder: "",
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "emergencyPhone",
			displayName: "Telefone de emergência (deixar vazio para remover do app)",
			validation: "",
			kind: "text",
			placeholder: "080012346",
		},
		{
			name: "emergencyEmail",
			displayName: "Email de emergência (deixar vazio para remover do app)",
			validation: "",
			kind: "text",
			placeholder: "fale@papauster.com.br",
		},
		{
			name: "emailDomainWhitelist",
			displayName: "Domínios de email permitidos (separados por vírgula, sem @)",
			validation: "",
			kind: "text",
			placeholder: "papauster.com.br,austernet.com",
		},
		{
			name: "cnpj",
			displayName: "CNPJ da empresa",
			validation: "length:14",
			kind: "text",
			placeholder: "",
		},
		{
			name: "cnpjMatriz",
			displayName: "CNPJ Matriz",
			validation: "length:14",
			kind: "text",
			placeholder: "",
		},
		{
			name: "emailStatistics",
			displayName: "E-mail da área do cliente (estatísticas de testes)",			
			kind: "text",
			placeholder: "",
		},
		{
			name: "emailStatistics2",
			displayName: "E-mail da área do cliente (estatísticas de testes 2)",			
			kind: "text",
			placeholder: "",
		},
		{
			name: "idSAP",
			displayName: "IDSAP",			
			kind: "text",
			placeholder: "",
		},
		{
			name: "inactive",
			displayName: "Inativo",			
			kind: "date",
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),			
			// notInResults: true,
			// mask: "##/##/####",
			placeholder: "DD/MM/AAAA",
		},
	];

	export default {
		create: async function (entity) {
			const response = await request.send("company", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("company", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (product) {
			let response = await request.send("company", "update", product, true);
			return response.data;
		},
		importCsv: async function(csv) {
			return request.send("company", "importCsv", { csv }, true);
		},
		remove: async function (id) {
			return request.send("company", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("company", "search", parameters, true);
		},
		getAll: async function() {
			const response = await request.send("company", "getAll", {}, true);
			return response.data;
		},
		getSchema: function() {
			return companySchema;
		},
		syncCompanies: async function() {
			const response = await request.send("company", "sap-sync", {}, true);
			return response.Data;
		},
		syncSubCompanies: async function(companyId) {
			const response = await request.send("company", "sap-company-sync", { companyId }, true);
			return response.data;
		}
	}
</script>
